'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var availableTrialsAdapter = function availableTrialsAdapter(availableTrials) {
  return availableTrials.map(function (trial) {
    var firstTrialParcel = trial.parcels && trial.parcels.length ? trial.parcels[0] : null;
    return {
      name: trial.name,
      trialId: trial.id,
      merchandiseId: firstTrialParcel && firstTrialParcel.merchandiseId || null
    };
  });
};

exports.default = availableTrialsAdapter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/adapters/availableTrialsAdapter.js
// module id = 279
// module chunks = 3 4 5